// extracted by mini-css-extract-plugin
export default {"buttonContainer":"static-landing-page-container__button-container__MruNv"};